import Assets from './assets'
import Contract from './contract'

export default { 
    Assets,
    Contract
}